import axios from "axios";
export const baseURLImg = "https://pc.nicoiehan.com";
export const baseURL = "https://pc.nicoiehan.com/api";
// export const baseURLImg = "https://test.nicoiehan.com";
// export const baseURL = "https://test.nicoiehan.com/api";

axios.create({
  baseURL: baseURL,
  timeout: 5000,
  headers: { "X-Custom-Header": "foobar" },
});

export const request = (url, method, data) => {
  let addData = {};
  console.log("请求接口地址", url);

  // data没有code的接口
  return new Promise((resolve, reject) => {
    console.log("进来了",localStorage.getItem("token"));
    axios
      .request({
        url: baseURL + url, //接口地址：前缀+方法中传入的地址
        method: method || "GET", //请求方法：传入的方法或者默认是“GET”
        // params: method == 'get' ? Object.assign(data, addData) || {}: {},
        // data: method == 'post' ? Object.assign(data, addData) || {} : {}, //传递参数：传入的参数或者默认传递空集合
        data: Object.assign(data, addData),
        headers: {
          "Content-Type": "application/json",
          "Form-type": "app",
          "token": localStorage.getItem("token") || ''
        },
      })
      .then((res) => {
        console.log("requestData", Object.assign(data, addData));
        console.log("response", res);
        if (res.status == 200) {
          resolve(res.data);
        }
       
        reject(res.data);
      })
      .catch((err) => {
        console.log("error", err);
        reject(err);
      });
  });
};
